import React from "react";
import {
  type GeneralWidthSyncArg,
  JSpreadSheetWrapWithResizeObserver,
  type JSpreadSheetWrapWithResizeObserverProps,
  generalWidthSync,
} from "../JSpreadSheetWrap";

export type JSpreadsheetDataTableProps = {
  getSpreadsheetOptions: JSpreadSheetWrapWithResizeObserverProps["getSpreadsheetOptions"];
  className?: string;
  reservedWidthForScrollbar?: GeneralWidthSyncArg["reservedWidthForScrollbar"];
  minColWidth?: GeneralWidthSyncArg["minColWidth"];
  fitToContainer?: boolean;
};
export const JSpreadsheetDataTable: React.FC<JSpreadsheetDataTableProps> = React.memo((p) => {
  const { getSpreadsheetOptions, className, reservedWidthForScrollbar, minColWidth, fitToContainer } = p;

  return (
    <JSpreadSheetWrapWithResizeObserver
      getSpreadsheetOptions={getSpreadsheetOptions}
      syncSpreadsheetSizes={React.useCallback(
        (rect, ref) =>
          fitToContainer !== false
            ? generalWidthSync({ ref, width: rect.width, reservedWidthForScrollbar, minColWidth })
            : undefined,
        [reservedWidthForScrollbar, fitToContainer],
      )}
      className={`${className ?? ""} [&_.jspreadsheetWrapCore_5BbCz_.jtabs-content]:h-full`.trim()}
    />
  );
});
JSpreadsheetDataTable.displayName = "components/JSpreadsheetDataTable";
